import api from './api';
import { getFcmToken, isMessagingSupported, subscribeOnMessage } from '../firebase';

let cachedToken = null;

const getServiceWorkerRegistration = async () => {
  if (!('serviceWorker' in navigator)) return null;
  const existing = await navigator.serviceWorker.getRegistration('/firebase-messaging-sw.js');
  if (existing) return existing;
  return navigator.serviceWorker.register('/firebase-messaging-sw.js');
};

export const registerWebDeviceToken = async () => {
  const supported = await isMessagingSupported();
  if (!supported) return null;

  const registration = await getServiceWorkerRegistration();
  const token = await getFcmToken(registration);
  if (!token) return null;

  cachedToken = token;
  localStorage.setItem('fcm_token', token);

  try {
    await api.post('/notifications/device-token', {
      platform: 'web',
      fcmToken: token,
      deviceId: navigator.userAgent,
      appVersion: process.env.REACT_APP_VERSION || 'web'
    });
  } catch (error) {
    console.error('Failed to register device token to backend', error);
  }

  return token;
};

export const unregisterWebDeviceToken = async () => {
  const token = cachedToken || localStorage.getItem('fcm_token');
  if (!token) return;

  try {
    await api.delete('/notifications/device-token', {
      data: { fcmToken: token }
    });
  } catch (error) {
    console.error('Failed to unregister device token', error);
  } finally {
    cachedToken = null;
    localStorage.removeItem('fcm_token');
  }
};

export const subscribeForegroundNotification = (handler) => {
  return subscribeOnMessage((payload) => {
    if (typeof handler === 'function') {
      handler(payload);
    }
  });
};
